export default __webpack_public_path__ + "static/media/layout.04329e1d.svg";